export const calculateRateCostSimple = (
  amount: number,
  advance: number,
  rate: number,
  days: number,
) => {
  const amountFinanced = amount * (advance / 100);
  console.log(amountFinanced);
  return (amountFinanced * rate * days) / 30 / 100;
};
